import Layout from '../../internal/Layout.vue'
import standardFilesRepository from './standardFilesRepository.vue'

const standardFilesRepositoryRoutes = {
  component: Layout,
  children: [
    {
      name: 'standardFilesRepository',
      path: '/',
      component: standardFilesRepository,
      meta: {
        module: 'filesRepository',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default standardFilesRepositoryRoutes
